import { connect } from 'react-redux';
import GlobalRanking from './GlobalRanking';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import {
  selectGlobalRankingTop,
  selectMyRange,
  isUserInTop
} from '@selectors/ranking';

export const mapStateToProps = state => ({
  total: get(state, 'globalRanking.total', 0),
  top: selectGlobalRankingTop(state),
  myRange: selectMyRange(state),
  showRange: !isEmpty(state.user) && !isUserInTop(state)
});

export default connect(mapStateToProps)(GlobalRanking);
